import React, { useState } from "react";
import BSToast from "react-bootstrap/Toast";

const Toast = ({ isShown, messageBg, message }) => {
  return (
    <>
      {isShown && (
        <BSToast
          className="d-inline-block m-1 toast-message"
          bg={messageBg ?? "success"}
        >
          <BSToast.Body className={"text-white"}>{message}</BSToast.Body>
        </BSToast>
      )}
    </>
  );
};

const useToast = () => {
  const [messageBg, setMessageBg] = useState("");
  const [message, setMessage] = useState("");
  const [isShown, setIsShown] = useState(false);

  return {
    setIsShown,
    setMessageBg,
    setMessage,
    Toast: () => (
      <Toast message={message} messageBg={messageBg} isShown={isShown} />
    ),
  };
};

export default useToast;
